import PropTypes from "prop-types";
import { ReactComponent as Close } from "../../../../assets/img/icon/close_black_24dp.svg";
import respinos from "../../../../assets/img/logo/Logo Respinos 4.png";
import Button from "../Button/Button";

const Modal = ({ handleClose, handleSubmit, show, children, submitLabel }) => {
  const handleCloseInt = () => {
    if (handleClose) handleClose();
  };
  const handleSubmitInt = () => {
    if (handleSubmit) handleSubmit();
  };
  return (
    <div
      className={
        "fixed top-0 left-0 right-0 min-h-screen bg-gray-900 bg-opacity-40 px-2 " +
        (show ? "opacity-100" : "opacity-30")
      }
      style={{ zIndex: show ? "20" : "-10" }}
    >
      <div
        className={
          "max-w-3xl bg-white shadow-lg mx-auto p-3 md:p-6 rounded-xl relative duration-100 ease-in " +
          (show ? "opacity-100 mt-16" : "opacity-30 mt-10")
        }
      >
        <button
          className="bg-red-200 focus:outline-none shadow rounded-full absolute top-0 right-0 mt-4 mr-4 lg:-mt-6 lg:-mr-6"
          onClick={handleClose}
        >
          <Close className="w-5 h-5 fill-current text-warning" />
        </button>

        <div>
          <img src={respinos} alt="" className="h-5" />
        </div>
        <div className="mt-3">{children}</div>
        <div className="mt-6 flex space-x-2 justify-end">
          <Button
            className="w-20 px-2 py-0.5 bg-warning rounded text-white"
            handleClick={handleCloseInt}
          >
            Batal
          </Button>
          <Button
            className="px-2 py-0.5 bg-success rounded text-white"
            handleClick={handleSubmitInt}
          >
            {submitLabel || "Simpan"}
          </Button>
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  submitLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};
export default Modal;
